module.exports = __webpack_public_path__ + "static/media/service_large_2.f1484952.jpg";